import Entity from '../entity'

export default class Withdrawal extends Entity<number>{
    amount: string  = null;
    userId: string  = null;
    userNo: string  = null;
    tenantId: number  = null;
    status: string  = null;
    remitUserName: string  = null;
    remitTime: string  = null;
    creationTime: string;
    remark: string  = null;
    vendorNo: string;
    vendorName: string;
    bankCardNo: string;
    userName: string;
}